$(function() {

    $('video#documentViewContent').height($('div.document-content').height() - 20);
    $('video').bind('contextmenu', function() { return false; });

	/*
	 * Check if page is a document view page
	 */

	var documentViewUrl = '/content/document/view';
	var documentViewContainsDocumentViewUrl = window.location.href.indexOf(documentViewUrl) > -1;
	var documentViewHasToolbar = $('.toolbar').length;

	if (documentViewContainsDocumentViewUrl && documentViewHasToolbar) {
		$('body').addClass('document-view-present');
	}

});